import FastCashInfo from './FastCashInfo';

export default FastCashInfo;
